<div mat-dialog-title class="w-100">
    <div
        class="title d-flex align-items-center justify-content-space-between pop-up-header head"
    >
        <h4 class="mb-0 pop-up-text">
          
        </h4>
        <button
            class="close-button"
            (click)="close()"
        >
            <i class="flaticon-close"></i>
        </button>
    </div>
</div>
<div class="body">
    <h1>Applicant's Agent Consent Form</h1>
    <div class="section">
        <h2>Information notice:</h2>
        
        <h3>What data will be collected</h3>
        <p>Data shared between Leeds Beckett University and your Agent may include your name, date of birth, academic qualifications, employment status, birth certificate, passport, immigration history and financial documents (required as part of your CAS/ visa application, if relevant). Only data required for the process of admission to the University will be required or shared.</p>
        
        <h3>What we will use your data for</h3>
        <p>Any data you or your Agent provides will be used to process your application to Leeds Beckett University. Your information will not be used for any other purpose.</p>
        
        <h3>Data Controller and collection</h3>
        <p>The organisation responsible for looking after your personal data (Data Controller) is Leeds Beckett University. Whilst Leeds Beckett University may share your data with the Agent, it will carefully control who is given access to that data.</p>
        <p>You and your Agent will be responsible for collecting data and passing it on to Leeds Beckett University.</p>
        
        <h3>Data Protection Officer</h3>
        <p>Leeds Beckett University's Data Protection Officer is Caroline Thomas. If you have any queries concerning the use of your data we can put you in contact with the international admissions team through internationaloffice{{this.emailComponent}}leedsbeckett.ac.uk.</p>
        <p>If you are not happy with the way your data is being handled, you have the right to complain to the Information Commissioner's Office.</p>
        
        <h3>Sharing your data</h3>
        <p>Your data will be shared with the Agent and Leeds Beckett University's recruitment and admissions teams. Your data will not be shared with any third party apart from the Agent, as per your consent on Page 2.</p>
        
        <h3>How long we will keep your data for</h3>
        <p>Your personal data (in so far as it identifies you as an individual) will be stored for as long as necessary in order to assist you with your application to the University and in line with the university's statutory obligations.</p>
        
        <h3>Your rights</h3>
        <p>You have the right to</p>
        <ul>
            <li><strong>Access</strong> – to access your personal data that we process.</li>
            <li><strong>Rectification</strong> – that any mistakes in the data held about you are corrected.</li>
            <li><strong>Erasure</strong> – that data held about you is deleted.</li>
            <li><strong>Restriction of rights to process</strong> – that you limit how the data about you is used.</li>
            <li><strong>Object</strong> to your data being processed.</li>
            <li><strong>Portability</strong> – for you to have your data given back to you in an accessible form so that you can take it somewhere else.</li>
            <li><strong>Withdraw</strong> – the right to decide you do not want to continue your application to the University, but you may be happy for us to keep the data you have already provided.</li>
        </ul>
        <p>For more information see Leeds Beckett University's data protection policy and privacy notice, which are updated from time to time are publically accessible at <a href="http://www.leedsbeckett.ac.uk/public-information/data-protection/">http://www.leedsbeckett.ac.uk/public-information/data-protection/</a></p>
    </div>
    
    <div class="section">
        <h1 class="add">To Be Completed by the Applicant:</h1>
    
    <p><em>Read the below statements and tick next to the statements if you agree</em></p>
    
    <table>
        <tr>
            <td><strong>I confirm</strong> I am interested in applying, or have applied, to Leeds Beckett University and am receiving advice and assistance from <span class="agent-name">CRIZAC LIMITED</span>
            <br><div class="instructions">(insert Agent name above)</div>
            </td>
            <td class="check-column">✓ tick below<br><br><span class="checkmark">✓</span></td>
        </tr>
        <tr>
            <td><strong>I consent</strong> for the Agent to act on my behalf, including in the submission of applications, communicating about my application directly with the university, and the signing of application declarations where required.</td>
            <td class="check-column"><span class="checkmark">✓</span></td>
        </tr>
        <tr>
            <td>If Leeds Beckett University provide me with an offer(s) of study, which I confirm I would like to accept, <strong>I consent</strong> for the Agent to accept this offer of study on my behalf either through the Agent Portal or by email confirmation. I understand that the acceptance of an offer of study will enter me into a Student Contract with the University.</td>
            <td class="check-column"><span class="checkmark">✓</span></td>
        </tr>
        <tr>
            <td><strong>I consent</strong> for the Agent to be copied in to communications between the University and myself.</td>
            <td class="check-column"><span class="checkmark">✓</span></td>
        </tr>
        <tr>
            <td><strong>I have read and understand</strong> the contents of this form and hereby agree for the sharing of my application and personal details (including financial documents when required) between the Agent and Leeds Beckett University, for the purposes of admission to the University and to assist in any CAS/visa application (if relevant).</td>
            <td class="check-column"><span class="checkmark">✓</span></td>
        </tr>
    </table>
    
    <div class="form-field">
        <strong>Applicant full name (capital letters):</strong> <span>{{fullName}}</span>
    </div>
    
    <div class="form-field">
        <strong>Applicant/Student ID number (if known):</strong>
    </div>
    
    <div class="form-field">
        <strong>Applicant email:</strong><span>{{email}}</span>
    </div>
    
    <div class="form-field">
        <strong>Applicant signature <em>(personal or electronic signatures will be accepted)</em>:</strong>
    </div>
    
    <div class="form-field">
        <strong>Date:</strong><span>{{date}}</span>
    </div>
    
    <div class="note">
        Please note that you (the applicant) have the right to withdraw this consent at any time. To do this please contact <a href="mailto:internationaloffice@leedsbeckett.ac.uk">internationaloffice{{this.emailComponent}}leedsbeckett.ac.uk</a> For further information on your rights, see "Information Notice" (Page 1)
    </div>
    <div class="button-container">
        <button class="submit-button" (click)="sendForSignature()">Send for signature</button>
    </div>
</div>

